<template>
  <a href="#employers-lt-order"
     @click.prevent="$scrollTo('#employers-lt-order', {offset: 0})"
     class="base-btn base-btn--blue">
    <span class="base-btn__text">{{ text || $tEmployersLT('Get help') }}</span>
    <BaseSvg width="0.5rem"
             height="1rem"
             name="ico-arrow-light"/>
  </a>
</template>

<script>
  export default {
    name: 'EmployersLTPageGetHelpBtn',
    props: {
      text: String
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less">

</style>
